import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import Menu from '../menu/menu.component';
import { useAuthStore, useThemeStore } from '../../store';

import styles from './protected-route.module.scss';

const ProtectedRoute = () => {
    const navigate = useNavigate();
    const { theme } = useThemeStore();
    const { accessToken, logout } = useAuthStore();

    useEffect(() => {
        if (!accessToken) {
            navigate('/login', { replace: true });
        }
    }, [accessToken]);

    const onLogout = () => {
        logout();
        return navigate('/login', { replace: true });
    };

    return accessToken ? (
        <div id={styles.layout}>
            <Menu onLogout={onLogout} theme={theme} />
            <Outlet />
        </div>
    ) : (
        <Navigate to={'/login'} replace />
    );
};

export default ProtectedRoute;
